import httpService from '@/api/httpService'

const DocumentApi = (() => {
  const apiPostfix = 'document'

  return {
    apiPostfix: apiPostfix,

    async getDocument (docId, docName) {
      const response = await httpService.post(`delivery/${apiPostfix}/view`, {
        doc_id: docId,
        doc_name: docName
      })
      return response.data
    },

    async getComment (docName, docId) {
      const response = await httpService.post(`delivery/${apiPostfix}/get_comment`, {
        doc_id: docId,
        doc_name: docName
      })
      return response.data
    },

    async getDebtInfo (docName, docId) {
      const response = await httpService.post(`delivery/${apiPostfix}/get_debt_info`, {
        doc_id: docId,
        doc_name: docName
      })
      return response.data
    },

    async saveComment (docName, docId, comment) {
      const response = await httpService.post(`delivery/${apiPostfix}/save_comment`, {
        doc_id: docId,
        doc_name: docName,
        comment: comment
      })
      return response.data
    },

    async addPayment (payload) {
      const response = await httpService.post(`delivery/${apiPostfix}/add_payment`, payload)
      return response.data
    },

    async setProcess (payload) {
      const response = await httpService.post(`delivery/${apiPostfix}/set_process`, payload)
      return response.data
    }
  }
})()

export default DocumentApi
